module.exports = __webpack_public_path__ + "media/images/flags/vg-372023debb62f1339555db60e899a507.svg";